import { Box, Table, TableBody, TableContainer } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmploymentsHierarchy } from "../../../talents/talentAPI";
import { EmploymentRowType } from "../types";
import BundleHeader from "./BundleHeader/BundleHeader";
import EmploymentRow from "./EmploymentRow";

interface Props {
  disabled: boolean;
  employmentBundle: EmploymentsHierarchy;
  // TODO: could this be sent from the backend for employment instead of being passed as a prop?
  continuousEmploymentId: string | undefined;
  translatedTESNames: { [key: string]: string };
  inner?: boolean;
  bundleOpen?: boolean;
  bundleIndex?: number;
  type: EmploymentRowType;
  isShift: boolean;
  isLastChild?: boolean;
  onRangeUpdated?: () => void;
}

const Bundle = ({
  disabled,
  employmentBundle,
  continuousEmploymentId,
  translatedTESNames,
  inner,
  bundleOpen,
  bundleIndex,
  type,
  isShift,
  isLastChild,
  onRangeUpdated,
}: Props) => {
  const [open, setOpen] = useState<boolean>(bundleOpen || false);

  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItem: "center",
        padding: "0px",
      }}
    >
      <BundleHeader
        open={open}
        setOpen={setOpen}
        employmentBundle={employmentBundle}
        title={`${
          t("talentProfile:bundle") + " " + employmentBundle.employerName
        }`}
        inner={inner}
        bundleId={"TODO: bundleId"}
        onRangeUpdated={onRangeUpdated}
      />

      {open && (
        <Box
          sx={{
            paddingBottom: isLastChild ? "0px" : "8px",
          }}
        >
          <TableContainer>
            <Table>
              <TableBody>
                {employmentBundle.employments.map(
                  (employment, employmentIndex) => (
                    <EmploymentRow
                      disabled={disabled}
                      key={`openEmpRow-${employmentIndex}-${employment.employmentId}}`}
                      index={employmentIndex}
                      type={type}
                      employment={employment}
                      tesName={translatedTESNames[employmentBundle.tesId]}
                      employerName={employmentBundle.employerName}
                      bundleIndex={bundleIndex}
                      isShift={isShift}
                      continuousEmploymentId={continuousEmploymentId}
                    />
                  ),
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
};

export default Bundle;
